"use strict";
module.exports = require('../../module.compiled').vendored['react-ssr'].React;

//# sourceMappingURL=react.js.map